import React, { useState, useContext, createContext } from "react";
import api from "../services/api";

export const visibilityContext = createContext();

function useVisibilityProvider() {
  const [pinnedTabs, setPinnedTabs] = useState([]);
  const [visibilityMap, setVisibilityMap] = useState({});

  // Define default search state
  const [searchMap, setSearchMap] = useState({
    employee: {
      filter: { isArchived: false, isPreHired: false },
      searchText: "",
      sortKey: null,
      sortDirection: "desc",
    },
  });

  const setSearchField = (key, field, value) => {
    // Field can be filter, searchText, sortKey, sortDirection
    if (!["filter", "searchText", "sortKey", "sortDirection"].includes(field)) {
      console.error("Field " + field + " not valid for " + key);
      return;
    }

    // Create if not exists
    if (!searchMap[key]) {
      searchMap[key] = {};
    }
    searchMap[key][field] = value;
    setSearchMap({ ...searchMap });
  };

  const savePinnedTabs = (tabs) => {
    setPinnedTabs(tabs);
    api.savePinnedTabs(tabs);
  };

  const onVisibilityChange = (visibilityKey, newVisibility) => {
    visibilityMap[visibilityKey] = newVisibility;
    setVisibilityMap({ ...visibilityMap });
    api.saveVisibility(visibilityMap);
  };

  return {
    // Pinned Tabs
    pinnedTabs,
    setPinnedTabs,
    savePinnedTabs,

    // Search
    searchMap,
    setSearchField,

    // Visibility
    setVisibilityMap,
    visibilityMap,
    onVisibilityChange,
  };
}

export function ProvideVisibility({ children }) {
  const values = useVisibilityProvider();
  return <visibilityContext.Provider value={values}>{children}</visibilityContext.Provider>;
}

export const useVisibility = () => {
  return useContext(visibilityContext);
};
